import { apiClient, handleResp } from './utils';
export default {
  getPlans() {
    return handleResp(apiClient().get('/payment/plans'));
  },
  getPricing() {
    return handleResp(apiClient().get('/payment/pricing'));
  },
  getTransactions() {
    return handleResp(apiClient().get('/payment/transactions'));
  },
  getBillingInfo() {
    return handleResp(apiClient().get('/payment/get_billing_info'));
  },
  getInvoicePdf(invoiceId) {
    return handleResp(
      apiClient({
        isFile: true,
        Accept: 'application/file',
      }).get('/payment/invoice?invoice_id=' + invoiceId),
    );
  },
  setBillingInfo(token) {
    return handleResp(apiClient().post('/payment/set_billing_info', { recurly_token: token }));
  },
  subscribe(planCode) {
    return handleResp(apiClient().post('/payment/subscribe', { plan_code: planCode }));
  },
  payInvoiceAndSubscribe(planCode) {
    return handleResp(
      apiClient().post('/payment/pay_and_subscribe', {
        plan_code: planCode,
      }),
    );
  },
};
